import { ReactNode } from "react";
import { SWRResponse } from "swr";
import { resourceIcon } from "~/pages/manifold-nextgen/components/resourceIcon";
import {
  nextgenConversationRedirectPath,
  nextgenDatasetPath,
  nextgenProjectPath,
} from "~/pages/manifold-nextgen/paths";
import { SearchEntityType } from "~/services/search";
import { ApiError, getApiErrorMessage } from "~/utils/apiClient";

export const ENTITY_TYPE_LABEL: Record<SearchEntityType, string> = {
  project: "Project",
  dataset: "Dataset",
  conversation: "Session",
};

/** An entity type's icon, at badge size. */
export const entityIcon = (entityType: SearchEntityType): ReactNode =>
  resourceIcon(entityType, "size-3.5");

/** Where a hit links. The index stores only an opaque id per type. */
export const entityHref = (entityType: SearchEntityType, entityId: string): string => {
  switch (entityType) {
    case "project":
      return nextgenProjectPath(entityId);
    case "dataset":
      return nextgenDatasetPath(entityId);
    case "conversation":
      return nextgenConversationRedirectPath(entityId);
  }
};

/** The part of a `useFetcher` result a read-only panel renders from. */
export type Fetched<T> = Pick<SWRResponse<T>, "data" | "error" | "isLoading">;

/** The server's message for a failed request, rather than its raw body. */
export const errorMessage = (error: unknown): string =>
  error instanceof ApiError ? getApiErrorMessage(error) : String(error);
